import type { IStorageImplementation } from '../@types';
import { getErrorMessage } from '../utils/getErrorMessage';
import { getLogger } from '../utils/SearchLogger';

export default class LocalStorageImpl implements IStorageImplementation {
	clear(): void {
		globalThis.localStorage.clear();
	}
	setItem(key: string, value: Record<string, any>): void {
		try {
			globalThis.localStorage.setItem(key, JSON.stringify(value));
		} catch (e) {
			getLogger().error('Local Storage Utils', 'Error writing to Local Storage', getErrorMessage(e));
		}
	}

	// Executes the getItem
	getItem(key: string): Record<string, any> | null {
		let item: Record<string, any> | null = null;

		try {
			const localStorageItem = globalThis.localStorage.getItem(key);

			if (localStorageItem) {
				// We JSON.parse it for you so that you don't have to
				item = JSON.parse(localStorageItem);
			}
		} catch (e) {
			getLogger().error('Local Storage Utils', 'Error reading from Local Storage', getErrorMessage(e));
		}

		return item;
	}

	// Executes the removeItem
	removeItem(key: string): void {
		globalThis.localStorage.removeItem(key);
	}
}
